"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi"
import './Services.css'

const Services = () => {
    const [services, setServices] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [selectedService, setSelectedService] = useState(null)
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        price: "",
        cost_rate: "",
        profit_rate: "",
        staff_share: "",
        company_share: "",
        is_active: true,
    })
    const [error, setError] = useState("")

    // --- YENİ STATE'LER ---
    const [pagination, setPagination] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        // --- DEĞİŞTİ: Sayfa 1'i yükle ---
        loadServices(1)
    }, []) //

    // --- DEĞİŞTİ: Artık 'page' parametresi alıyor ---
    const loadServices = async (page = 1) => {
        setLoading(true) // Her yüklemede loading'i göster
        try {
            // --- DEĞİŞTİ: API'ye sayfa bilgisi gönder ---
            const response = await api.get(`/services?page=${page}`)

            // --- HATA DÜZELTMESİ: 'data' dizisini al ---
            setServices(response.data.data) //

            // --- YENİ: Sayfalama verisini state'e at ---
            const { data, ...paginationData } = response.data
            setPagination(paginationData)
            setCurrentPage(response.data.current_page)

        } catch (error) {
            console.error("Hizmetler yüklenemedi:", error)
        } finally {
            setLoading(false) //
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        try {
            if (selectedService) {
                await api.put(`/services/${selectedService.id}`, formData)
            } else {
                await api.post("/services", formData)
            }
            setShowModal(false)
            resetForm()
            // --- DEĞİŞTİ: Mevcut sayfayı yenile ---
            loadServices(currentPage) //
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız")
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu hizmeti silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/services/${id}`)
            // --- DEĞİŞTİ: Mevcut sayfayı yenile ---
            loadServices(currentPage) //
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const handleEdit = (service) => {
        setSelectedService(service)
        setFormData({
            name: service.name,
            description: service.description || "",
            price: service.price,
            cost_rate: service.cost_rate,
            profit_rate: service.profit_rate,
            staff_share: service.staff_share,
            company_share: service.company_share,
            is_active: service.is_active,
        })
        setShowModal(true)
    }

    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            price: "",
            cost_rate: "",
            profit_rate: "",
            staff_share: "",
            company_share: "",
            is_active: true,
        })
        setSelectedService(null)
        setError("")
    }

    // --- YENİ: Sayfa değiştirme fonksiyonu ---
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setCurrentPage(newPage)
            loadServices(newPage)
        }
    }

    // --- YENİ: Sayfalama UI'ını render etme fonksiyonu ---
    const renderPagination = () => {
        if (!pagination || pagination.last_page <= 1) {
            return null
        }

        return React.createElement(
            "div",
            { className: "pagination-container" },
            React.createElement(
                "button",
                {
                    className: "btn btn-secondary",
                    onClick: () => handlePageChange(currentPage - 1),
                    disabled: currentPage === 1,
                },
                "Önceki"
            ),
            React.createElement(
                "span",
                { className: "pagination-info" },
                `Sayfa ${pagination.current_page} / ${pagination.last_page}`
            ),
            React.createElement(
                "button",
                {
                    className: "btn btn-secondary",
                    onClick: () => handlePageChange(currentPage + 1),
                    disabled: currentPage === pagination.last_page,
                },
                "Sonraki"
            )
        )
    }


    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    return React.createElement(
        "div",
        { className: "services-page" }, //
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "Hizmet Yönetimi"),
            React.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: () => {
                        resetForm()
                        setShowModal(true)
                    },
                },
                React.createElement(FiPlus),
                "Yeni Hizmet",
            ),
        ),
        React.createElement(
            "div",
            { className: "card" },
            React.createElement(
                "div",
                { className: "table-container" },
                React.createElement(
                    "table",
                    { className: "desktop-table" },
                    React.createElement(
                        "thead",
                        null,
                        React.createElement(
                            "tr",
                            null,
                            React.createElement("th", null, "Hizmet Adı"),
                            React.createElement("th", null, "Fiyat"),
                            React.createElement("th", null, "Gider Oranı"),
                            React.createElement("th", null, "Kar Oranı"),
                            React.createElement("th", null, "Durum"),
                            React.createElement("th", null, "İşlemler"),
                        ),
                    ),
                    React.createElement(
                        "tbody",
                        null,
                        // --- ARTIK HATA VERMEYECEK ---
                        services.map((service) => //
                            React.createElement(
                                "tr",
                                { key: service.id },
                                React.createElement("td", null, service.name),
                                React.createElement("td", null, `₺${service.price}`),
                                React.createElement("td", null, `%${service.cost_rate}`),
                                React.createElement("td", null, `%${service.profit_rate}`),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "span",
                                        { className: `badge ${service.is_active ? "badge-success" : "badge-danger"}` },
                                        service.is_active ? "Aktif" : "Pasif",
                                    ),
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "div",
                                        { className: "action-buttons" },
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon", onClick: () => handleEdit(service) },
                                            React.createElement(FiEdit2),
                                        ),
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon danger", onClick: () => handleDelete(service.id) },
                                            React.createElement(FiTrash2),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            React.createElement(
                "div",
                { className: "mobile-cards" },
                // --- ARTIK HATA VERMEYECEK ---
                services.map((service) => //
                    React.createElement(
                        "div",
                        { key: service.id, className: "mobile-card" },
                        React.createElement(
                            "div",
                            { className: "mobile-card-header" },
                            React.createElement("h3", null, service.name),
                            React.createElement(
                                "div",
                                { className: "action-buttons" },
                                React.createElement(
                                    "button",
                                    { className: "btn-icon", onClick: () => handleEdit(service) },
                                    React.createElement(FiEdit2),
                                ),
                                React.createElement(
                                    "button",
                                    { className: "btn-icon danger", onClick: () => handleDelete(service.id) },
                                    React.createElement(FiTrash2),
                                ),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-body" },
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Fiyat:"),
                                React.createElement("span", { className: "value" }, `₺${service.price}`),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Gider Oranı:"),
                                React.createElement("span", { className: "value" }, `%${service.cost_rate}`),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Kar Oranı:"),
                                React.createElement("span", { className: "value" }, `%${service.profit_rate}`),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Durum:"),
                                React.createElement(
                                    "span",
                                    { className: `badge ${service.is_active ? "badge-success" : "badge-danger"}` },
                                    service.is_active ? "Aktif" : "Pasif",
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        ),

        // --- YENİ: Sayfalama UI'ı buraya eklendi ---
        renderPagination(),

        showModal &&
        React.createElement(
            // ... (Modal içeriği aynı, değişiklik yok) ...
        )
    )
}

export default Services